export const BACKGROUND_JOB_STATUS = {
  SUCCEEDED: 'succeeded',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  IN_PROGRESS: 'in-progress'
};
